import React from "react";

import { Scheduler } from "2g-scheduler";

import useRezervaceVytoverniScheduler from "./hooks/useRezervaceVytoverniScheduler";

export function RezervaceVytvoreniScheduler() {
  const { visible, ...shceduler } = useRezervaceVytoverniScheduler();

  return visible ? <Scheduler {...shceduler} /> : null;
}

RezervaceVytvoreniScheduler.propTypes = {};

export default React.memo(RezervaceVytvoreniScheduler);
